import { create } from "zustand";

const useStore = create((set) => ({
  showHomeIntro: true,
  setShowHomeIntro: (value) => set({ showHomeIntro: value }),
  showProjectsMenu: false,
  setShowProjectsMenu: (value) => set({ showProjectsMenu: value }),
}));

export default useStore;
